import React, { Component } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import {
  Grid,
  Paper,
  Button,
  Checkbox,
  FormControlLabel,
  Typography,
  ListItemAvatar,
  Avatar,
} from "@material-ui/core";
import Snackbar from "../../snackbar";
import Header from "../../../partials/header";
import { styles } from "./style";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import InputFormat from "../../../partials/inputForm";
import { _parsePhoneNumber } from "../../../partials/validateNumber";
import {
  send_notification_all_services,
  send_notification_all_users,
} from "../../../utils/setting";
import Loading from "../../loading";
export class NotificationSend extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sendAllUser: true,
      sendAllServiceOwner: true,
      sendAllCustomer: false,
      users: [],
      serviceOwner: [],
      rowsPerPage: 10,
      page: 0,
      pageService: 0,
      customers: [],
      allUser: [],
      allService: [],
      allCustomer: [],
      fullUserList: false,
      fullServiceList: false,
    };
  }
  componentDidMount() {
    const { notifySending, templateNotification } = this.props;
    if (
      Object.keys(templateNotification).length === 0 &&
      Object.keys(notifySending).length === 0
    ) {
      this.getTemplate();
    }
  }
  getTemplate = async () => {
    this.loading.startLoading();
    let check = await this.props.getTemplate();
    this.loading.stopLoading();
    if (check.code === 1) {
      this.props.setNotifySending(check.data || {});
    }
  };
  handleToggle = (name, value) => () => {
    let state = this.state;
    let checked = state[name];
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    state[name] = newChecked;
    this.setState(state);
  };
  getAllUser = async (payload = {}) => {
    this.loading.startLoading();
    let check = await this.props.getAllUser({
      limit: this.state.rowsPerPage,
      page: this.state.page,
      ...payload,
    });
    this.loading.stopLoading();
    if (check.code === 1) {
      let { allUser } = this.state;
      allUser = payload.search
        ? check.data.list
        : allUser.concat(check.data.list);
      this.setState({
        page: this.state.page + 1,
        allUser: allUser,
        fullUserList: check.data.list.length === 0 ? true : false,
      });
    } else
      this.setState({
        fullUserList: true,
      });
  };
  getListServicesForAdmin = async (payload = {}) => {
    this.loading.startLoading();
    let check = await this.props.getListServicesForAdmin({
      limit: this.state.rowsPerPage,
      page: this.state.pageService,
      filter_exact: [{ isActive: 1 }],
      ...payload,
    });
    this.loading.stopLoading();
    if (check.code === 1) {
      let result = check.data.list.filter((e) => e.userCode != null);
      let { allService } = this.state;
      allService = payload.search ? result : allService.concat(result);
      this.setState({
        pageService: this.state.pageService + 1,
        allService: allService,
        fullServiceList: result.length === 0 ? true : false,
      });
    } else
      this.setState({
        fullServiceList: true,
      });
  };
  getListCustomer = async (payload) => {
    this.loading.startLoading();
    let check = await this.props.getListCustomer(payload);
    if (check.code === 1) this.setState({ allCustomer: check.data.list });
    this.loading.stopLoading();
  };
  handleChange = (name, value) => {
    let state = this.state;
    state[name] = value;
    this.setState(state);
    if (name === "sendAllUser" && value === false) this.getAllUser();
    if (name === "sendAllServiceOwner" && value === false)
      this.getListServicesForAdmin();
  };
  handleChangeSearch = async (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let state = this.state;
    state[name] = value;
    this.setState(state);
    if (name === "searchUser") {
      this.getAllUser({ search: value, page: 0 });
    } else if (name === "searchService") {
      this.getListServicesForAdmin({ search: value, page: 0 });
    } else if (name === "searchCustomer") {
      this.getListCustomer({ search: value, page: 0 });
    }
  };
  // Send to user (ADMIN)
  handleSendNotify = async () => {
    let {
      serviceOwner = [],
      users = [],
      sendAllUser = false,
      sendAllServiceOwner = false,
    } = this.state;
    let { notifySending } = this.props;
    if (notifySending && notifySending.title) {
      this.loading.startLoading();
      await this.props.sendNotifyFromSuperAdmin({
        data: notifySending,
        serviceOwner: sendAllServiceOwner
          ? [send_notification_all_services]
          : serviceOwner,
        users: sendAllUser ? [send_notification_all_users] : users,
      });
      this.loading.stopLoading();
      if (this.props.history) this.props.history.push("/notification");
    }
  };
  // Send to customer (owner/employee SPA)
  handleSendNotifyToCustomer = async () => {
    let { t, notifySending } = this.props;
    let { sendAllCustomer, customers } = this.state;
    if (notifySending && notifySending.title) {
      this.loading.startLoading();
      await this.props.sendNotifyFromOwnerService({
        data: notifySending,
        customers: sendAllCustomer ? [send_notification_all_users] : customers,
      });
      this.loading.stopLoading();
      if (this.props.history) this.props.history.push("/notification");
    } else {
      this.mSnackbar.handleClick(
        t("notification_send_not_have_template"),
        "warning"
      );
    }
  };

  render() {
    const { t, classes, role, notifySending } = this.props;
    let {
      sendAllServiceOwner,
      sendAllUser,
      sendAllCustomer,
      page,
      allUser,
      allCustomer,
      fullUserList,
      fullServiceList,
      searchUser,
      searchService,
      searchCustomer,
      users,
      customers,
      allService,
      serviceOwner,
    } = this.state;
    return (
      <>
        <Snackbar onRef={(snackbar) => (this.mSnackbar = snackbar)} />
        <Header
          session={t("notification_notification")}
          title={t("notification_send_notification")}
          backIcon={true}
          actionBack={() => this.props.history.push("/notification")}
        />
        <Loading onRef={(id) => (this.loading = id)} />
        <Paper className={classes.paper}>
          {role !== "admin" ? (
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12} md={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      // disabled={disabled}
                      checked={sendAllCustomer}
                      onChange={(e) =>
                        this.handleChange(e.target.name, e.target.checked)
                      }
                      name="sendAllCustomer"
                      color="primary"
                    />
                  }
                  label={t("notification_send_to_all_customer")}
                />
              </Grid>
              {sendAllCustomer !== true && (
                <Grid item xs={12} sm={12} md={12}>
                  <InputFormat
                    name="searchCustomer"
                    label={t("notification_search_by_name")}
                    margin="normal"
                    value={searchCustomer}
                    onChange={this.handleChangeSearch}
                  />

                  <List className={classes.list}>
                    {allCustomer.map((value) => {
                      const labelId = `checkbox-list-label-${value}`;
                      return (
                        <ListItem
                          key={value.customerCode}
                          role={undefined}
                          dense
                          button
                          onClick={this.handleToggle(
                            "customers",
                            value.customerCode || value.code
                          )}
                        >
                          <ListItemIcon>
                            <Checkbox
                              edge="start"
                              checked={
                                customers.indexOf(
                                  value.customerCode || value.code
                                ) !== -1
                              }
                              tabIndex={-1}
                              disableRipple
                              inputProps={{ "aria-labelledby": labelId }}
                            />
                          </ListItemIcon>
                          <ListItemAvatar>
                            <Avatar
                              alt={value.customerName}
                              src={value.customerImage}
                            />
                          </ListItemAvatar>
                          <ListItemText
                            primary={value.customerName}
                            secondary={
                              <React.Fragment>
                                <Typography
                                  component="span"
                                  variant="body2"
                                  className={classes.inline}
                                  color="textPrimary"
                                >
                                  {
                                    _parsePhoneNumber(
                                      value.countryCode,
                                      value.customerMobile
                                    ).format_national
                                  }
                                </Typography>
                                {value.customerAddress
                                  ? `- ${value.customerAddress}`
                                  : ``}
                              </React.Fragment>
                            }
                          />
                          <ListItemSecondaryAction>
                            <ListItemText id={labelId} primary={value.price} />
                          </ListItemSecondaryAction>
                        </ListItem>
                      );
                    })}
                  </List>
                </Grid>
              )}
              <Grid item xs={12} sm={12} justify="flex-end" container={true}>
                <Button
                  className={classes.button}
                  variant="contained"
                  color="primary"
                  onClick={() => this.handleSendNotifyToCustomer()}
                >
                  {t("notification_send")}
                </Button>
              </Grid>
            </Grid>
          ) : (
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12} md={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      // disabled={disabled}
                      checked={sendAllUser}
                      onChange={(e) =>
                        this.handleChange(e.target.name, e.target.checked)
                      }
                      name="sendAllUser"
                      color="primary"
                    />
                  }
                  label={t("notification_send_to_all_user")}
                />
              </Grid>
              {sendAllUser !== true && (
                <Grid item xs={12} sm={12} md={12}>
                  <InputFormat
                    name="searchUser"
                    label={t("notification_search_by_name")}
                    margin="normal"
                    value={searchUser}
                    onChange={this.handleChangeSearch}
                  />

                  <List className={classes.list}>
                    {allUser.map((value) => {
                      const labelId = `checkbox-list-label-${value}`;
                      return (
                        <ListItem
                          key={value.userCode}
                          role={undefined}
                          dense
                          button
                          onClick={this.handleToggle("users", value.userCode)}
                        >
                          <ListItemIcon>
                            <Checkbox
                              edge="start"
                              checked={users.indexOf(value.userCode) !== -1}
                              tabIndex={-1}
                              disableRipple
                              inputProps={{ "aria-labelledby": labelId }}
                            />
                          </ListItemIcon>
                          <ListItemAvatar>
                            <Avatar
                              alt={value.nickName}
                              src={value.avatarImage}
                            />
                          </ListItemAvatar>
                          <ListItemText
                            primary={value.firstName + value.lastName}
                            secondary={
                              <React.Fragment>
                                <Typography
                                  component="span"
                                  variant="body2"
                                  className={classes.inline}
                                  color="textPrimary"
                                >
                                  {
                                    _parsePhoneNumber(
                                      value.countryCode,
                                      value.username
                                    ).format_national
                                  }
                                </Typography>
                                {value.address ? `- ${value.address}` : ""}
                              </React.Fragment>
                            }
                          />
                          <ListItemSecondaryAction>
                            <ListItemText id={labelId} primary={value.price} />
                          </ListItemSecondaryAction>
                        </ListItem>
                      );
                    })}
                    {!fullUserList && (
                      <div
                        className={classes.loadMore}
                        onClick={() => this.getAllUser(page)}
                      >
                        {t("notification_load_more")}
                      </div>
                    )}
                  </List>
                </Grid>
              )}
              <Grid item xs={12} sm={12} md={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      // disabled={disabled}
                      checked={sendAllServiceOwner}
                      onChange={(e) =>
                        this.handleChange(e.target.name, e.target.checked)
                      }
                      name="sendAllServiceOwner"
                      color="primary"
                    />
                  }
                  label={t("notification_send_to_all_owner_service")}
                />
              </Grid>
              {sendAllServiceOwner !== true && (
                <Grid item xs={12} sm={12} md={12}>
                  <InputFormat
                    name="searchService"
                    label={t("notification_search_by_name")}
                    margin="normal"
                    value={searchService}
                    onChange={this.handleChangeSearch}
                  />

                  <List className={classes.list}>
                    {allService.map((value) => {
                      const labelId = `checkbox-list-label-${value}`;
                      return (
                        <ListItem
                          key={value.no}
                          role={undefined}
                          dense
                          button
                          onClick={this.handleToggle("serviceOwner", value.no)}
                        >
                          <ListItemIcon>
                            <Checkbox
                              edge="start"
                              checked={serviceOwner.indexOf(value.no) !== -1}
                              tabIndex={-1}
                              disableRipple
                              inputProps={{ "aria-labelledby": labelId }}
                            />
                          </ListItemIcon>
                          <ListItemAvatar>
                            <Avatar alt={value.name} src={value.logo} />
                          </ListItemAvatar>
                          <ListItemText
                            primary={value.name}
                            secondary={
                              <React.Fragment>
                                <Typography
                                  component="span"
                                  variant="body2"
                                  className={classes.inline}
                                  color="textPrimary"
                                >
                                  {value.address}
                                </Typography>
                                {value.phone ? `- ${value.phone}` : ``}
                              </React.Fragment>
                            }
                          />
                          <ListItemSecondaryAction>
                            <ListItemText id={labelId} primary={value.price} />
                          </ListItemSecondaryAction>
                        </ListItem>
                      );
                    })}
                    {!fullServiceList && (
                      <div
                        className={classes.loadMore}
                        onClick={() => this.getListServicesForAdmin(page)}
                      >
                        {t("notification_load_more")}
                      </div>
                    )}
                  </List>
                </Grid>
              )}
              <Grid item xs={12} sm={12} justify="flex-end" container={true}>
                <Button
                  className={classes.button}
                  variant="contained"
                  color="primary"
                  onClick={() => this.handleSendNotify()}
                >
                  {t("notification_send")}
                </Button>
              </Grid>
            </Grid>
          )}
        </Paper>
      </>
    );
  }
}

const mapState = (state) => ({
  notifySending: state.notification.notifySending,
  templateNotification: state.templateNotification.templateNotification,
  allUser: state.user.allUser,
  totalUser: state.user.total,
  countUser: state.user.count,
  role: state.user.user.roleId.role,
});

const mapDispatch = (dispatch) => ({
  setNotifySending: dispatch.notification.setNotifySending,
  notification: dispatch.notification,
  getAllUser: dispatch.user.getAllUser,
  getListServicesForAdmin: dispatch.service.getListServicesForAdmin,
  sendNotifyFromSuperAdmin: dispatch.notification.sendNotifyFromSuperAdmin,
  sendNotifyFromOwnerService: dispatch.notification.sendNotifyFromOwnerService,
  getListCustomer: dispatch.customer.getListCustomer,
  getTemplate: dispatch.templateNotification.getTemplate,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: 0 })(NotificationSend)
  )
);
